module.exports = __webpack_public_path__ + "img/template.e2964e09.svg";